import { NotificationsActive } from '@mui/icons-material'
import { Typography } from '@mui/material'
import React from 'react'
import { VBox } from '../../elements/basic-elements'
import { FormBox, TextButtonBase } from '../../elements/form-elements'
import StandardButton from '../buttons/standard-button'
import CenteredModal from '../modals/centered-modal'

/**
 * Asks to turn on push for this device when the account has push enabled but this
 * browser hasn't been asked for permission yet. The browser's permission prompt can
 * only be triggered by a user gesture, hence the modal + button.
 */
const PushEnableModal = ({
  open,
  enabling,
  onEnable,
  onDismiss
}: {
  open: boolean
  enabling?: boolean
  onEnable: () => void
  onDismiss: () => void
}) => (
  <CenteredModal open={open} onClose={onDismiss} showClose>
    <FormBox padding={{ xs: '8px 0px 16px', sm: '8px 8px 16px' }}>
      <VBox alignItems="center" gap={2.5}>
        <NotificationsActive sx={{ fontSize: 56, opacity: 0.4, mt: 1 }} />
        <VBox gap={1} textAlign="center">
          <Typography variant="h5" color="textPrimary" fontWeight={600}>
            Turn on push notifications for this device?
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Push notifications are on for your account, but this browser isn't set up to receive
            them yet. Enable them to get updates here even when What Can I Do isn't open.
          </Typography>
        </VBox>
        <VBox alignItems="center" gap={1.5} sx={{ mt: 1 }}>
          <StandardButton variant="contained" onClick={onEnable} disabled={enabling}>
            {enabling ? 'Enabling…' : 'Enable'}
          </StandardButton>
          <TextButtonBase
            onClick={onDismiss}
            sx={{ fontSize: 14, color: 'text.secondary', fontWeight: 400 }}
          >
            Not now
          </TextButtonBase>
        </VBox>
      </VBox>
    </FormBox>
  </CenteredModal>
)

export default PushEnableModal
